export default __webpack_public_path__ + "e208bb18f618d23f21fba7fa8f6e1056.png";